export default __webpack_public_path__ + "static/media/icebitlogo.bf9db5dc.png";